/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { InputConfig } from "./InputConfig";
import { InputConstraint } from "./InputConstraint";
export const InputField = core.serialization.object({
    key: core.serialization.string(),
    label: core.serialization.string(),
    description: core.serialization.string().optional(),
    type: core.serialization.string(),
    defaultValue: core.serialization.any().optional(),
    config: InputConfig.optional(),
    constraints: core.serialization.list(InputConstraint).optional(),
});
